<template>
  <div
    v-if="person"
    class="g-person-merz__wrapper"
    :class="modusOption?(modusOption.key.replace('b_','')+'smodus'):'default'"
  >   
    <template v-for="(it,pi) of person.merzItems1">
      <!-- <div
        style="font-weight:bold"
        class="ksm-flex"
      >{{it.merz.name.trim().replace('Merz','Merz ')}} &nbsp;&nbsp;</div>-->
      <!-- neue Zeile -->
      <div class="ksm-flex-1" :key="pi">
        <span style="font-weight:bold">{{it.merz.name.trim().replace('Merz','Merz ')}} &nbsp;&nbsp;</span>
      
        <template v-for="(it2,pi2) of it.seiten">
          {{pi2>0?'&nbsp;&bull;':''}}
          <a
            :key="'s'+pi2"
            @click="toPath(it, it2, person.lemmaID)"
            :class="isSeiteSelected(it, it2, person.lemmaID)?'ksm-acco-person-expand':''"
          >{{it2.name.length>20?it2.name:it2.name.replace(/\s/g,'&nbsp;')}}</a>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "g-person-merz",
  props: ["person", "modusOption"],
  data() {
    return {};
  },
  computed: {
    accoExpandPersonList() {
      if (this.modusOption) {
        return this.modusOption.accoExpandPersonList;
      }
    }
  },
  methods: {
    isSeiteSelected(it, it2, perId) {
      const query = this.$route.query;
      if (!query) {
        return;
      }
      const merzId = query.merzId;
      if (!merzId) {
        return;
      }
      const seiteIdx = query.seiteIdx;
      return it.merz.id === merzId && seiteIdx - it2.idx === 0;
    },
    
    toPath(it, it2, perId) {
      const option = this.modusOption;
      const query = {
        merzId: it.merz.id,
        seiteIdx: it2.idx
      };
      const b_query = {
        b_merzId: it.merz.id,
        b_seiteIdx: it2.idx
      };

      let useQuery;
      let path;
      let modusId;

      //vergleich b_
      if (option && option.key.match(/^b_/)) {
        modusId = "vergleichsmodus";
        useQuery = b_query;
      } else if (option) {
        modusId = option.key + "smodus";
        useQuery = query;
      } else {
        // view Personen
        modusId = "untersuchungsmodus";
        useQuery = query;
      }

      //TODO
      const merzName = it.merz.name;
      if (merzName.indexOf("Merz") === 0) {
        path = "/texte/merzhefte/" + modusId;
      } else if (merzName === "ursonate") {
      } else {
        // from texte goto merzwerbe
        if (
          this.$route.name === "texte-modus" &&
          modusId === "vergleichsmodus"
        ) {
          useQuery = query;
        }
        path = "/merzwerbe/untersuchungsmodus";
      }

      this.$store.commit("addAccoPersonList", {
        path: path,
        query: useQuery,
        perId: perId,
        merzId: it.merz.id,
        seiteIdx: it2.idx
      });

      if (!path) {
        this.$router.push({
          query: useQuery
        });
      } else {
        this.$router.push({
          path: path,
          query: useQuery
        });
      }
    }
  }
};
</script>
 
<style lang="scss" scoped>
.g-person-merz__wrapper {
  &.default {
    a {
      cursor: pointer;
      color: $blue1;
      &:hover {
        color: $darkRed !important;
      }
    }
  }
  .ksm-acco-person-expand {
    background-color: rgba(150, 65, 65, 0.315);
  }
}
</style>


// WEBPACK FOOTER //
// PersonMerz.vue?25ca1133